import { useState, useEffect } from "react";
import { useGetAllGroupQuery } from "src/services/GroupService";

const useGroup = () => {
    const [group, setGroup] = useState<any[]>([]);
    const [isDataLoading, setIsDataLoading] = useState(true);

    const { data, isLoading, isFetching } = useGetAllGroupQuery("");

    useEffect(() => {
        if (isLoading || isFetching) {
            setIsDataLoading(true);
        } else {
            const result: any[] = data?.data;
            setGroup(result || []);
            setIsDataLoading(false);
        }
    }, [data, isLoading, isFetching]);

    return { group, isDataLoading };
};

export default useGroup;
